<template>
  <div class="company-body">
    <div class="title">企业信息</div>
    <div class="form-content">
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="公司名称" prop="company_name">
          <el-input
            v-model="ruleForm.company_name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司地址" prop="address">
          <el-input v-model="ruleForm.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input v-model="ruleForm.contact"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="contact_tel">
          <el-input v-model="ruleForm.contact_tel"></el-input>
        </el-form-item>
        <el-form-item label="邮箱账号" prop="email">
          <el-input
            v-model="ruleForm.email"
            placeholder="方便发送报价单"
          ></el-input>
        </el-form-item>
        <el-form-item label="需要查找的药品" prop="product">
          <el-input
            v-model="ruleForm.product"
            placeholder="多个药品以逗号隔开"
          ></el-input>
        </el-form-item>
        <el-form-item label="营业执照" prop="business_license_image">
          <el-upload
            class="avatar-uploader"
            :action="url"
            :show-file-list="false"
            :headers="headers"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :on-progress="uploadImageProcess"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
              :class="imageFlag ? 'transparent0' : ''"
            ></i>
            <el-progress
              v-if="imageFlag == true"
              type="circle"
              :percentage="imageUploadPercent"
              style="margin-top:30px;"
            ></el-progress>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- Matomo Image Tracker-->
    <img
      src="https://piwik.sosyao.com/matomo.php?idsite=15&amp;rec=1"
      style="border:0"
      alt=""
    />
    <!-- End Matomo -->
  </div>
</template>

<script>
import { setUserCompany } from "@api/user";
import { VUE_APP_API_URL } from "@utils";
import { compress, compressAccurately } from "image-conversion";

export default {
  name: "AuthCompany",
  data() {
    var contact_telCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入联系人手机号码"));
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error("请输入正确手机号码"));
        } else {
          callback();
        }
      }
    };
    var emailCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱账号"));
      } else {
        if (
          // eslint-disable-next-line no-useless-escape
          !/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(
            value
          )
        ) {
          callback(new Error("请输入正确的邮箱账号"));
        } else {
          callback();
        }
      }
    };
    return {
      ruleForm: {
        company_name: "",
        address: "",
        contact: "",
        contact_tel: "",
        email: "",
        product: "",
        business_license_image: []
      },
      rules: {
        company_name: [
          { required: true, message: "请填写贵公司的名称", trigger: "change" }
        ],
        address: [
          { required: true, message: "请填写贵公司的地址", trigger: "change" }
        ],
        contact: [
          { required: true, message: "请填写贵公司的联系人", trigger: "change" }
        ],
        contact_tel: [
          { required: true, validator: contact_telCheck, trigger: "blur" }
        ],
        email: [{ required: true, validator: emailCheck, trigger: "blur" }],
        product: [
          { required: true, message: "请填写需要的药品", trigger: "change" }
        ]
      },
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      url: `${VUE_APP_API_URL}/upload/image`,
      imageUrl: "", //上传的图片
      imageFlag: false,
      imageUploadPercent: 0
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.imageUrl) {
            this.$dialog.toast({ mes: "请上传营业执照" });
          } else {
            setUserCompany(this.ruleForm)
              .then(res => {
                if (res.status == 200) {
                  this.$router.push({
                    path: "/user/verify"
                  });
                }
              })
              .catch(err => console.log(err));
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.imageUrl = "";
      this.$refs[formName].resetFields();
    },
    handleAvatarSuccess(res) {
      this.imageFlag = false; //去掉进度条
      this.imageUploadPercent = 0; //去掉进度条
      this.imageUrl = res.data.url;
      this.ruleForm.business_license_image[0] = this.imageUrl;
    },
    beforeAvatarUpload(file) {
      this.imageFlag = true;
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 2; // 判定图片大小是否小于4MB
        if (isLt2M) {
          resolve(file);
        }
        console.log(file); // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        compressAccurately(file, 2048)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 上传进度
    uploadImageProcess(event, file) {
      this.imageUploadPercent = file.percentage.toFixed(0);
    }
  }
};
</script>

<style lang="scss" scoped>
.company-body {
  background: #fff;
  .title {
    font-size: 18px;
    line-height: 6vh;
    height: 6vh;
    color: #666;
    background: rgba($color: #000000, $alpha: 0.1);
    text-align: center;
  }
  .form-content {
    padding: 3vh 5% 3vh 1%;
    .pictrue {
      width: 3rem;
      height: auto;
      img {
        width: 100%;
      }
    }
    .transparent0 {
      opacity: 0;
    }
  }
}
</style>
<style>
.el-form-item__label {
  font-size: 16px;
  text-align: center;
}

.g-core-image-upload-form input {
  height: 35px;
  width: 80px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form-item__content {
  margin-left: 80px;
}
.el-form-item:nth-child(6) .el-form-item__label {
  line-height: 20px;
}
.avatar-uploader .el-progress {
  position: absolute;
  top: 0;
  left: 15%;
}
</style>
